import { createContext, useCallback, useContext } from 'react';

import type { ReactNode } from 'react';

type EventType = 'paymentOptionClick' | 'receiptOptionClick';

type LogEvent = (params: unknown) => void;

export type EventRegistry = Record<EventType, LogEvent>;

type AnalyticsContext = {
  logEvent: (name: EventType, params: unknown) => void;
  analKey: string | undefined;
};

const Context = createContext<AnalyticsContext>({
  logEvent: () => {
    console.error('AnalyticsProvider not found.');
  },
  analKey: undefined,
});

export const AnalyticsProvider = ({
  children,
  eventRegistry,
  analKey,
}: {
  children: ReactNode;
  eventRegistry: EventRegistry;
  analKey: string | undefined;
}) => {
  const logEvent = useCallback(
    (name: EventType, params: unknown) => {
      eventRegistry[name](params);
    },
    [eventRegistry],
  );

  return (
    <Context.Provider value={{ logEvent, analKey }}>
      {children}
    </Context.Provider>
  );
};

export const useLogEvent = () => {
  const { logEvent } = useContext(Context);

  return logEvent;
};

export const useAnalKey = () => {
  const { analKey } = useContext(Context);

  return analKey;
};
